module.exports = __webpack_public_path__ + "img/EASTASIA_HIGH_GLYCEMIC.52116787.png";